module.exports = __webpack_public_path__ + "img/W-V13.9007aa56.jpg";